import styled from 'styled-components'

import { Color } from '@/utils'

export const TableElement = styled.table`
  display: table;
  border-spacing: 0;

  // Remove right border from each row last cell
  .table-head .table-header:last-of-type .table-cell,
  .table-body .table-data:last-of-type .table-cell,
  .table-foot .table-header:last-of-type .table-cell {
    border-right-width: 0;
  }

  // Remove bottom border from last row cells
  .table-body .table-row:last-of-type .table-cell,
  .table-foot .table-row:last-of-type .table-cell {
    border-bottom-width: 1px;
  }

  // Every odd row has background
  .table-body .table-row:nth-child(odd) {
    background: ${Color.opacitySky};
  }

  // First row of footer has top border
  .table-foot .table-row:first-of-type .table-cell {
    border-top-width: 1px;
  }

  .table-body .table-row .table-data:first-of-type [data-selected] {
    border-left: 1px solid ${Color.primary};
  }

  .table-body .table-row .table-data:last-of-type [data-selected] {
    border-right: 1px solid ${Color.primary};
  }
`